var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('img',{staticClass:"w-100",attrs:{"src":require("@/assets/images/train_cover.jpg")}}),_c('br'),_c('br'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.getCaption('caption.train_schedule_content'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }